/**
 * AlertsStrip — the L1 alert band that surfaces above the OMEGA
 * status section when any alerts are active.
 *
 * Per spec §3 (information hierarchy) the L1 page leads with
 * "Health, brain status grid, recent alerts." The alert strip
 * is the third of those three — high contrast, click-through to
 * /omega/alerts. When `count === 0` the strip renders nothing
 * (no chrome takes space when there's nothing to show).
 */

import { Link } from 'react-router-dom';
import { TriangleAlert } from 'lucide-react';

export function AlertsStrip({ count }: { count: number }) {
  if (count === 0) return null;
  return (
    <Link
      to="/omega/alerts"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--omega-gap-1)',
        background: 'rgba(239, 68, 68, 0.08)',
        borderLeft: '3px solid var(--omega-state-critical)',
        borderTop: '1px solid var(--omega-rim)',
        borderRight: '1px solid var(--omega-rim)',
        borderBottom: '1px solid var(--omega-rim)',
        padding: 'var(--omega-gap-1) var(--omega-gap-2)',
        marginBottom: 'var(--omega-gap-2)',
        textDecoration: 'none',
        color: 'var(--omega-ink)',
      }}
    >
      <TriangleAlert
        size={14}
        strokeWidth={2.4}
        color="var(--omega-state-critical)"
        aria-hidden
      />
      <span
        style={{
          fontSize: '10pt',
          letterSpacing: '0.04em',
          color: 'var(--omega-ink)',
          fontWeight: 600,
        }}
      >
        {count} active alert{count === 1 ? '' : 's'}
      </span>
      <span style={{ flex: 1 }} />
      <span
        style={{
          fontSize: '9pt',
          color: 'var(--omega-ink-muted)',
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
        }}
      >
        Open inbox →
      </span>
    </Link>
  );
}
